import React from 'react';
import { Inline } from '@/Components/ui/layout';
import { Stack } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';

export const PricingContent = () => {
  return (
    <Inline spacing="xl" align="center" className="gap-[136px] w-full -mt-[100px] flex-wrap">
      <Stack spacing="md" className="flex-1">
        <Heading level="h1" className="text-[28px] font-semibold text-foreground mb-4">
          Buy Premium Subscription to Post a Job
        </Heading>
        <Text size="base" className="text-muted-foreground leading-6">
          Take your recruitment process to the next level with cutting-edge AI
          technology that streamlines every step of hiring.
        </Text>
      </Stack>
      <img 
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2e1ceb35d73a2014d758a675cef5f350b136ae6b20c0fb5b53c42bba475f7196?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
        alt="Pricing illustration"
        className="w-[250px] aspect-[1.22] object-contain" 
      />
    </Inline>
  );
};
